import React from 'react';
import styled from 'styled-components';
import {useAppDispatch} from "@features/store/store";
import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";

const IconImage = styled.img`
    width: 22px;
    height: 22px;
    cursor: pointer;
    
`;

interface IconProps {
    img: string;
    onClick?: () => AnyAction | ThunkAction<void, unknown, unknown, AnyAction>;
}

const Icon: React.FC<IconProps> = ({ img, onClick }) => {
    const dispatch = useAppDispatch();

    const handleResetData = () => {
        if (onClick) {
            dispatch(onClick());
        }
    };

    return <IconImage src={img} alt="icon" onClick={handleResetData} />;
};

export default Icon;
